<template lang="">
   <v-row>
      <v-col cols="8">
        <v-card 
        class="mx-auto"
    >
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-form
        class="m-5"
    ref="form"
    lazy-validation
  >
    <v-text-field
      v-model="name"
      :counter="20"
      label="Nombre de la empresa"
      required
    ></v-text-field>

    

    <v-btn
      :disabled="!name"
      color="primary"
      class="mr-4"
      @click="subirEmpresa" 
      :loading="status"
    >
      Generar
    </v-btn>

     
  </v-form>
        </v-col>
      </v-row>
    </v-container>
        
    </v-card>
      </v-col>
      <v-col cols="4">
         
         <v-card>
             <div v-for="item in empresa" :key="item.id">
                <v-list-item v-if="item.Nombre != 'Sin asignacion'">
                  <v-list-item-content>
                      <v-list-item-title>
                        {{item.Nombre}}
                        <v-btn @click.prevent="selected(item)" class="mx-2 my-2" fab dark small elevation="3" color="primary">
                          <v-icon dark>mdi-pencil</v-icon>
                        </v-btn>
                      </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
             </div>
         </v-card>
       
         
          
      </v-col>
      
        <div class="text-center">
            <v-overlay light opacity="0.48" z-index="100" :value="edicion">
      <v-card
      light
    class="mx-auto"
    min-width="600"
  >
      <v-btn
        icon
        @click="edicion = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
            
            

    <v-card-subtitle class="pb-0">Edición de empresa</v-card-subtitle>

    <v-card-text class="text--primary">
      <v-col cols="12" class="d-flex align-content-end">
         <v-col cols="12" class="d-flex align-content-end">
              <v-text-field
                label="Empresa"
                placeholder="Empresa"
                outlined
                v-model="select.Nombre"
              ></v-text-field>
          </v-col>              
      </v-col>
    </v-card-text>



    <v-card-actions>
       <v-col cols="12">
     <v-btn
       :disabled="false"
        color="primary"
        @click.prevent="editEmpresa"
      >
        Guardar
      </v-btn>

      <v-btn
       :disabled="false"
        color="danger"
        dark
        @click.prevent="dialog = true"
      >
        Eliminar
      </v-btn>

     
        </v-col>
    </v-card-actions>
  </v-card>
    </v-overlay>
        </div>


    <v-dialog
      v-model="dialog"
      width="500"
      z-index="9999"
    >
    

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Eliminar ( {{select.Nombre}} )
        </v-card-title>

        <v-card-text>
          Estas seguro que quieres Eliminar
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          
          
          <v-btn
            color="primary"
            text
            @click="Delete"
          >
            Si
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
  
            <v-btn
            color="seccundary"
            text
            @click="dialog = !dialog"
          >
            no
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>


    </v-row>
    
</template>
<script>

import {SubirEnterprise,EditEnterprise,DeleteEnterprise} from '../../../../../../../services/team/enterprise'
import Table from '../../../../../component/helpers/tools/table'

export default {
    
    components:{

        Table

    },

    mounted() {
        this.$store.dispatch('GetEmpresas');
    },

    data(){
        return {
            status:false,
            //empresa:'',
            type:'empresa',
            edicion:false,
            dialog:false,
            select:'',
            name:'',
            nameRules: [
                v => !!v || 'Name is required',
                v => (v && v.length <= 20) || 'Name must be less than 10 characters',
            ],

            header: [
                {
                    text: 'Nombre de Empresas',
                    align: 'left',
                    sortable: true,
                    value: 'name',
                },
                
                
                
        ],
       }
    },

    computed: {
        
        empresa(){
            
            return this.$store.state.Enterprise;
            
        }

    },

    

    methods: {
        
        vaciarcampos:function(){

            this.name = '';

        },

        selected:function(item){
          this.edicion = !this.edicion;
          this.select = item;
        },
        
    

        subirEmpresa:function(){
            this.$store.dispatch('LoadingFetchActions', true);
            this.status = true;
            SubirEnterprise({'nombre':this.name}).then(response=>{
                this.$router.push({path: '/config/empresas'});
                this.$store.dispatch('GetEmpresas');
                this.$toastr.success('Se ha agregado correctamente la empresa');
                this.status = false;
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
            }).catch(errors=>{
                this.status = false;
                this.$toastr.error(errors)
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
            });
        },

        editEmpresa:function(){

            this.$store.dispatch('LoadingFetchActions', true);
            this.status = true;
            EditEnterprise(this.select.id,{'Nombre':this.select.Nombre}).then(response=>{
                this.$router.push({path: '/config/empresas'});
                this.$store.dispatch('GetEmpresas');
                this.$toastr.success('Se ha editado correctamente la empresa');
                this.edicion = false;
                this.status = false;
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
            }).catch(errors=>{
                this.status = false;
                 this.edicion = false;
                this.$toastr.error(errors)
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
            });
        },

        Delete:function(){

            this.$store.dispatch('LoadingFetchActions', true);
            this.status = true;
            DeleteEnterprise(this.select.id).then(response=>{
                this.$router.push({path: '/config/empresas'});
                this.$store.dispatch('GetEmpresas');
                this.$toastr.success('Se ha eliminado correctamente la empresa');
                this.status = false;
                 this.edicion = false;
                 this.dialog = false;
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
            }).catch(errors=>{
                this.status = false;
                this.$toastr.error(errors)
                this.vaciarcampos();
                 this.edicion = false;
                 this.dialog = false;
                this.$store.dispatch('LoadingFetchActions', false);
            });
          

        }

        
    },

}
</script>